import { ref } from 'vue'

const APP_INDEX_CONTAINER_ID = 'appContainer'
const APP_NAVIGATOR_CONTAINER_ID = 'navigatorMenu'

export const useMicroAppContainer = () => {
  const appContainerId = APP_INDEX_CONTAINER_ID
  const appNavigatorContainerId = APP_NAVIGATOR_CONTAINER_ID

  return {
    appContainerId,
    appNavigatorContainerId,
  }
}
